<template>
    <div class="side-bar">
        <ul>
            <li @mouseover="activeShow">
                <img  :src="serve_img"/>
                客服电话
            </li>
            <li @mouseover="emailShow">
                <img :src="email_img"/>
                邮件
            </li>
            <li v-for="(item,index) in pdfUrl" :key="index" @click="goDetail(item.outer_url,item.id)">
                <img :src="COV_img"/>
                {{item.title}}
            </li>
            <!-- <li @click="goDetail(1)">
                <img :src="statement_icon"/>
                严正声明
            </li> -->
        </ul>
        <div ref="serve"  @mouseleave="activeHide" class="active">
            <div class="serve-active">
            <div><img :src="serve2_img"/>客服电话</div>
            <div class="tel"><div style="font-size:18px;">8610 - 8418 5298</div><div>周一至周五 9:00 - 18:00</div></div>
        </div>
        </div>
        <div ref="email" class="email-active"  @mouseleave="emailHide" @click="sendEmail()">
            <div><img :src="email2_img"/> 点击即可发送至管家邮箱</div>
            <div>hanlandpropertymanagement@hanlandglobal.com</div>
        </div>
        <div class="go-top" @click="blackTop" >
            <img class="top-img" :src="top_img" />
        </div>
    </div>
</template>
<script>
import serve_img from '@assets/image/icon/serve.png'
import serve2_img from '@assets/image/icon/serve2.png'
import email_img from '@assets/image/icon/email.png'
import email2_img from '@assets/image/icon/email2.png'
import COV_img from '@assets/image/icon/COV.png'
import top_img from '@assets/image/icon/top-row.png'
import statement_icon from '@assets/image/icon/statement_icon.png'

export default {
    name:'sideBarComponent',
    components:{
       
    },
    data() {
        return {
            serve_img,serve2_img,email_img,email2_img,COV_img,top_img,
            statement_icon,
            pdfUrl:{}
        }
    },
    mounted(){
        this.getPdfUrl()
    },
    methods:{
        blackTop () {
            window.scrollTo({ top: 0, behavior: "smooth"})
        },
        activeShow () {
            this.$refs.serve.style.display = 'block'
        },
        activeHide (){
            this.$refs.serve.style.display = 'none'
        },
        emailShow () {
            this.$refs.email.style.display = 'block'
        },
        emailHide (){
            this.$refs.email.style.display = 'none'
        },
        sendEmail (){
           window.open('mailto:hanlandpropertymanagement@hanlandglobal.com', '_top') 
        },
        getPdfUrl (){
            var that = this
            this.axios.get(this.url+'/api/web/cms/official',{}).then(function(response){
                that.pdfUrl = response.data.data;
            }).catch(function() {
            });
        },
        goDetail (url,id){
            if(url){
                window.open(url,'_blank')
            }else{
                window.open('/article?id='+ id,'_blank')
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.side-bar{
    position:fixed;
    right: 1rem;
    bottom: 5rem;  
    font-size: 14px;
    text-align: center;
    color: $color;
    z-index:999;
    cursor: pointer;
    img{
        display: block;
        margin: 0 auto 4px;
    }
}
ul{
    display: flex;
    width: 70px;
	height: auto;
    padding: 12px 0;
	border-radius: 8px;
    border: solid 1px #cdd3da;
    background-color: #ffffff;
    position: relative;
    flex-direction: column;
    justify-content:space-around;
    li:not(:last-child){
        margin-bottom: 16px;
    }
}
.active{
    display: none;
}
.serve-active{
    position: absolute;
    top:0;
    right: 0;
    width: 296px;
	height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #c2a16c;
	background-color: #0e2d57;
    border-radius: 80px 8px 8px 80px;
    img{
    }
    .tel{
        margin-left: 10px;
        font-weight: 700;
        line-height: 24px;
        margin-top: 12px;
    }
}
.email-active{
    position: absolute;
    top:70px;
    right: 0;
    width: 367px;
	height: 70px;
    color: #c2a16c;
    padding-top:16px;
    display: none;
	background-color: #0e2d57;
    border-radius: 80px 8px 8px 80px;
    img{
        display: inline-block;
    }
}
.go-top{
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: 1px solid #cdd3da;
    margin: 40px auto 0;
    cursor: pointer;
    background: #ffffff;
    .top-img{
        margin-top: 16px;
    }
}
@media only screen and (max-width: 1024px){
    .side-bar{
        display: none;
    }
}
</style>